import { useIsLoggedIn } from '../../../../context/AuthMachine';
import { useGiftCardInfoQuery } from '../../graphql/GiftCardInfo.generated';

export const useGiftCardBalance = () => {
  const isLoggedIn = useIsLoggedIn();

  const [{ data, fetching }] = useGiftCardInfoQuery({
    pause: !isLoggedIn,
    requestPolicy: 'network-only',
  });

  const giftCardBalance =
    data?.giftCardBalance?.__typename === 'GiftCardBalance'
      ? data.giftCardBalance.giftCardBalance
      : 0;

  return {
    giftCardBalance,
    isFetchingGiftCardBalance: fetching,
  };
};
